/* tslint:disable */

declare var Object: any;
export interface SFLeaveCancelRequestSF6Interface {
  "id"?: number;
}

export class SFLeaveCancelRequestSF6 implements SFLeaveCancelRequestSF6Interface {
  "id": number;
  constructor(data?: SFLeaveCancelRequestSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLeaveCancelRequestSF6`.
   */
  public static getModelName() {
    return "SFLeaveCancelRequestSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLeaveCancelRequestSF6 for dynamic purposes.
  **/
  public static factory(data: SFLeaveCancelRequestSF6Interface): SFLeaveCancelRequestSF6{
    return new SFLeaveCancelRequestSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLeaveCancelRequestSF6',
      plural: 'SFLeaveCancelRequestSF6s',
      path: 'SFLeaveCancelRequestSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLeaveCancelRequestSF6.ts